/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_InvoicePost } from '../models/Model_InvoicePost';
import type { Model_PagedInvoiceGet } from '../models/Model_PagedInvoiceGet';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvoiceService {
    /**
     * @param customerId
     * @param isCreditNote
     * @param requestBody
     * @returns Model_PagedInvoiceGet Success
     * @throws ApiError
     */
    public static postApiV1Invoice(
        customerId: ConvertDatesToStrings<string>,
        isCreditNote: ConvertDatesToStrings<boolean> = false,
        requestBody?: ConvertDatesToStrings<Model_InvoicePost>,
    ): CancelablePromise<Model_PagedInvoiceGet> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoice/{customerId}',
            path: {
                'customerId': customerId,
            },
            query: {
                'IsCreditNote': isCreditNote,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
